var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader?{\"cacheDirectory\":true,\"presets\":[[\"env\",{\"modules\":false,\"targets\":{\"browsers\":[\"> 2%\"],\"uglify\":true}}]]}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./TabsContent.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-98b3fd62\",\"hasScoped\":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./TabsContent.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./resources/js/components/TabsContent.vue
// module id = 4GXG
// module chunks = 1